// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"40":"3304809d","278":"4235896f","436":"ce3c4e55","587":"705511b9","885":"c7279baf","949":"f8815ce3"}[chunkId] + ".css";
};